import { Component, OnInit } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-sms-edit',
  templateUrl: './sms-edit.component.html',
  styleUrls: ['./sms-edit.component.css'],
  providers: [ MessageService]
})
export class SmsEditComponent implements OnInit {
  statusList:SelectItem[] = [];
  smsfromList:SelectItem[] = [];
  surveysList:SelectItem[] = [];

  errors: {
    smsNameError: boolean,

  };
  sms={
    name:'',
    text:'',
    from:'',
    status:''
  }
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
     
    this.smsfromList.push({label:'Please select ...',value:''});
    this.sms.from=this.smsfromList[0]['id'];
    this.statusList.push({label:'DRAFT',value:'DRAFT'});
    this.statusList.push({label:'READY TO SEND',value:'READY TO SEND'});
  
    this.apiService.get('surveys/sm_senders',{}).subscribe(data => {
      data.Result.forEach((d)=>{
        this.smsfromList.push({label:d.from_name,value:d.from_name});
      });
      if( this.smsfromList.length>0){
        this.sms.from=this.smsfromList[0]['value'];
      }
     });

    this.apiService.get('surveys/listall',{}).subscribe(data => {
      this.surveysList=data.Result;
      if( this.surveysList.length>0){
      //  this.sms['id_survey']=this.surveysList[0];
      }
      if (this.route.snapshot.paramMap.get('id')) {
        this.apiService.get('surveys/smslistall',{}).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==parseInt(this.route.snapshot.paramMap.get('id'))){
              this.sms=g;
              if(this.sms['status']=='READY TO SEND'){
                this.sms['to_send']=true;
              } else {
                this.sms['to_send']=false;
              }
              for (const r of this.surveysList) {
                if(r['id']==this.sms['id_survey']){
              //  this.sms['id_survey']=r;
                }
              }
            }
          }
        });
      }
      });
    
  }

  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

    
  private initErrors() {
    this.errors = {} as any;
  }
 
 

  private validate() : boolean {
    let isValid : boolean = true;
   
    if (this.sms.name=='') {
      this.addSingle('error', 'Error', 'Field name is mandatory');
        isValid = false;
    }

    if (this.sms.text=='') {
      this.addSingle('error', 'Error', 'Field text is mandatory');
        isValid = false;
    }

    
    if (this.sms.from=='') {
      this.addSingle('error', 'Error', 'Field from is mandatory');
        isValid = false;
    }

  
    
    
  
    return isValid;
  }


  public save() {

    
      if (!this.validate()) return;


      this.apiService.updateSMS(this.sms).subscribe(data => {
        this.addSingle('success', 'Successo', 'SMS Updated');
     //   this.router.navigateByUrl('/dashboard/surveys/sms');
      });
    

  }
  

}
